export const DIRECTIONS = [
  { key: "Меньше", short: "<", memory: 0 },
  { key: "Равно", short: "=", memory: 1 },
  { key: "Больше", short: ">", memory: 2 },
];

export function resolveDirectionFromStorage() {
  const stored = sessionStorage.getItem("condition_version_client");
  return DIRECTIONS.find((d) => d.key === stored) ?? DIRECTIONS[2];
}

/** @param {unknown} version */
export function normalizeSoftVersionDigits(version) {
  if (version == null || version === "") {
    return "";
  }
  return String(version).replace(/[.rR]/g, "");
}

/**
 * Сравнение версии софта с порогом для отчёта «Версия софта».
 * @param {unknown} softwareVersion
 * @param {unknown} thresholdVersion
 * @param {0|1|2} mode 0 — меньше, 1 — равно (префикс порога), 2 — больше
 */
export function compareSoftVersionForReport(
  softwareVersion,
  thresholdVersion,
  mode,
) {
  const s = normalizeSoftVersionDigits(softwareVersion);
  const t = normalizeSoftVersionDigits(thresholdVersion);
  if (!s || !t) {
    return false;
  }

  if (mode === 1) {
    const prefix = s.slice(0, t.length);
    const prefixNum = Number(prefix);
    const thresholdNum = Number(t);
    if (Number.isNaN(prefixNum) || Number.isNaN(thresholdNum)) {
      return false;
    }
    return prefixNum === thresholdNum;
  }

  const len = Math.max(s.length, t.length);
  const sn = Number(s.padEnd(len, "0"));
  const tn = Number(t.padEnd(len, "0"));
  if (Number.isNaN(sn) || Number.isNaN(tn)) {
    return false;
  }
  if (mode === 0) {
    return sn < tn;
  }
  if (mode === 2) {
    return sn > tn;
  }
  return false;
}
